import { useTranslation } from 'react-i18next'

export function UnRecommendations() {
  const { t } = useTranslation()
  return (
    <section
      aria-labelledby='un-recommendations-heading'
      className='flex flex-col gap-8 md:gap-12 px-6 py-25 bg-gray-50 text-center text-md md:text-xl leading-relaxed opacity-90'
    >
      <h3 id='un-recommendations-heading' className='text-4xl md:text-5xl font-medium'>
        {t('home.recommendationsTitle')}
      </h3>
      <article>
        <h4 className='bold underline pb-4'>
          <b className='text-2xl'>{t('home.recommendationsRussia')}</b>
        </h4>
        <ol>
          <li className='mb-2 text-2xl leading-relaxed'>{t('home.rusRec1')}</li>
          <li className='mb-2 text-2xl leading-relaxed'>{t('home.rusRec2')} </li>
          <li className='mb-2 text-2xl leading-relaxed'>{t('home.rusRec3')}</li>
        </ol>
      </article>
      <article>
        <h4 className='bold underline pb-4'>
          <b className='text-2xl'>{t('home.recommendationsUNStates')}</b>
        </h4>
        <ol>
          <li className='mb-2 text-2xl leading-relaxed'>{t('home.statesRec1')}</li>
          <li className='mb-2 text-2xl leading-relaxed'>{t('home.statesRec2')}</li>
        </ol>
      </article>
    </section>
  )
}
